import { UserMapper } from '../mapper/UserMapper';

export const userMapper = new UserMapper();
